export const EU = [
  'at',
  'be',
  'bg',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fr',
  'gr',
  'hr',
  'hu',
  'ie',
  'it',
  'lt',
  'lu',
  'lv',
  'mt',
  'nl',
  'pl',
  'pt',
  'ro',
  'se',
  'si',
  'sk',
];

export const EEA = ['is', 'li', 'no'];

export const EMEA = [
  ...EU,
  ...EEA,
  'ae',
  'ax',
  'az',
  'ba',
  'bf',
  'bh',
  'bi',
  'bj',
  'bl',
  'bv',
  'by',
  'cd',
  'cf',
  'cg',
  'ch',
  'ci',
  'ck',
  'cm',
  'cv',
  'dj',
  'dz',
  'eg',
  'eh',
  'er',
  'et',
  'fo',
  'ga',
  'gb',
  'ge',
  'gf',
  'gg',
  'gh',
  'gi',
  'gl',
  'gm',
  'gn',
  'gp',
  'gq',
  'gw',
  'hm',
  'il',
  'im',
  'iq',
  'ir',
  'is',
  'je',
  'jo',
  'ke',
  'kg',
  'km',
  'kw',
  'kz',
  'lb',
  'li',
  'lr',
  'ls',
  'ly',
  'ma',
  'mc',
  'md',
  'me',
  'mf',
  'mg',
  'mk',
  'ml',
  'mq',
  'mr',
  'mu',
  'mw',
  'mz',
  'na',
  'nc',
  'ne',
  'ng',
  'om',
  'pf',
  'pm',
  'ps',
  'qa',
  're',
  'rs',
  'ru',
  'rw',
  'sa',
  'sc',
  'sd',
  'sh',
  'sl',
  'sm',
  'sn',
  'so',
  'ss',
  'st',
  'sx',
  'sy',
  'sz',
  'td',
  'tf',
  'tg',
  'tj',
  'tm',
  'tn',
  'tr',
  'tz',
  'ua',
  'ug',
  'uz',
  'va',
  'wf',
  'ye',
  'yt',
  'za',
  'zm',
  'zw',
];

const NA_REGIONS = [
  'AR',
  'AU',
  'AW',
  'BB',
  'BR',
  'BM',
  'BO',
  'CA',
  'CL',
  'CN',
  'CO',
  'CR',
  'CW',
  'DO',
  'EC',
  'GT',
  'GU',
  'HN',
  'IN',
  'JM',
  'JP',
  'KR',
  'KY',
  'MX',
  'MY',
  'NI',
  'NZ',
  'PA',
  'PE',
  'PR',
  'PY',
  'SG',
  'SR',
  'SV',
  'TT',
  'UM',
  'US',
  'UY',
  'VG',
  'VI',
];

export const getRegion = country => {
  const NARegions = NA_REGIONS;
  return NARegions.includes(country) ? 'NA' : 'EMEA';
};

export const isEMEA = countryCode => EMEA.includes(countryCode.toLowerCase());

export const isEU = (countryCode: string) =>
  [...EU, ...EEA].includes(countryCode.toLowerCase());
